export default {
  fields: {
    country: 'Pays de la banque',
    iban: 'IBAN',
    routing_number: 'Numéro de routage',
    account_number: 'Numéro de compte',
    sort_code: 'Code guichet (sort code)',
    account_type: 'Type de compte',
  },
  help: {
    country: 'Le pays de la banque, qui peut différer de celui du restaurant.',
  },
  placeholders: {
    iban: 'DE89 3704 0044 0532 0130 00',
  },
  formats: {
    uk_local: {
      title: 'Sort code et numéro de compte',
      description: 'La manière habituelle de saisir un compte britannique.',
    },
    iban: {
      title: 'IBAN',
      description: 'Le numéro de compte bancaire international.',
    },
    us_local: {
      title: 'Numéro de routage et de compte',
      description: 'Un compte bancaire américain.',
    },
  },
  account_types: {
    checking: 'Compte courant',
    savings: 'Compte épargne',
  },
  actions: {
    save: 'Enregistrer le compte bancaire',
    cancel: 'Annuler',
    edit: 'Modifier',
  },
  card: {
    account: 'Compte',
    country: 'Pays',
    status: 'Statut',
  },
  statuses: {
    active: 'Actif',
    pending_verification: 'En cours de vérification',
    action_needed: 'Action requise',
    errored: 'Échec du virement',
    missing: 'Manquant',
  },
  notes: {
    pending_verification:
      'Adyen vérifie chaque compte bancaire avant le début des virements. Confirmez-le sur la page d’Adyen avec une connexion bancaire ou un relevé bancaire.',
    action_needed:
      'Le prestataire de paiement n’a pas pu confirmer ce compte bancaire. Vérifiez les informations ou saisissez un autre compte.',
    errored:
      'Un virement vers ce compte a échoué et les virements sont suspendus. Vérifiez les informations ou saisissez un autre compte.',
  },
};
